import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import EMITracker2PageUI from './EMITracker2PageUI.js'

class EMITracker2PageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorList: null,
            accountList: null,
            prepaymentAccountList: null,
            accountNRList: null,
            accountRList: null,
            totals: null,
            checked: false,
            year: null,
            month: null,
            view: false,
            downloadSubmitted: false,
            downloadMode: false,

            allocationUpdateMode: false,
            reasonUpdateMode: false,
            selectedLoanId: null,
            currentAllocation: null,
            currentReason: null,

            isToCollect: false,
            onlyType: 'business',
            saveSuccessMsg: null,
            saveLoading: false,
            collectionLoading: false,
            approveLoading: false,
            saveAndApproveStep: null,

            auditLogsResponse: null,
            selectedAllocationTab: 'All',
            allocationFilter: '',
            repaymentsLoading: true,
        }
    }

    render() {
        console.log("SF state:", this.state.auditLogsResponse)
        return (
            <EMITracker2PageUI
                context={this.props.context}
                errorList={this.state.errorList}
                accountList={this.state.accountList}
                prepaymentAccountList={this.state.prepaymentAccountList}
                accountRList={this.state.accountRList}
                accountNRList={this.state.accountNRList}
                downloadSubmitted={this.state.downloadSubmitted}
                downloadMode={this.state.downloadMode}
                totals={this.state.totals}
                checked={this.state.checked}
                view={this.state.view}
                yearMonth={this.state.yearMonth}
                year={this.state.year}
                month={this.state.month}
                onPreviousClick={this.onPreviousClick}
                onNextClick={this.onNextClick}
                onShowDetailsChange={this.onShowDetailsChange}
                onViewChange={() => this.setState({ view: !this.state.view })}
                onRefreshClick={this.onRefreshClick}
                onTypeChange={this.onTypeChange}
                onEMITrackerDownload={this.onEMITrackerDownload}
                onSaveEMITracker={this.onSaveEMITracker}
                onCollectionEMI={this.onCollectionEMI}
                onApprovePayables={this.onApprovePayables}
                onSaveAndApprove={this.onSaveAndApprove}
                saveAndApproveStep={this.state.saveAndApproveStep}

                allocationUpdateMode={this.state.allocationUpdateMode}
                onAllocationUpdateClick={this.onAllocationUpdateClick}
                onAllocationUpdateCancelClick={() => { this.setState({ allocationUpdateMode: false }) }}
                onAllocationUpdateSuccess={this.onAllocationUpdateSuccess}
                reasonUpdateMode={this.state.reasonUpdateMode}
                onReasonUpdateClick={this.onReasonUpdateClick}
                onReasonUpdateCancelClick={() => { this.setState({ reasonUpdateMode: false, currentReason: null }) }}
                onReasonUpdateSuccess={this.onReasonUpdateSuccess}
                isToCollect={this.state.isToCollect}
                selectedLoanId={this.state.selectedLoanId}
                currentAllocation={this.state.currentAllocation}
                currentReason={this.state.currentReason}
                onlyType={this.props.onlyType ? this.props.onlyType : this.state.onlyType}
                saveSuccessMsg={this.state.saveSuccessMsg}
                saveLoading={this.state.saveLoading}
                collectionLoading={this.state.collectionLoading}
                approveLoading={this.state.approveLoading}

                auditLogsResponse={this.state.auditLogsResponse}
                selectedAllocationTab={this.state.selectedAllocationTab}
                onAllocationTabChange={this.onAllocationTabChange}
                repaymentsLoading={this.state.repaymentsLoading}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        this.getRepayments(context)
        
        const today = new Date()
        const lastDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
        ).getDate()

        if (today.getDate() === lastDayOfMonth) {
        this.auditLogPoller = setInterval(() => {
            const currentYear = this.state.year || ''
            const currentMonth = this.state.month || ''

            this.getAuditLogs(context, currentYear, currentMonth)
        }, 30000) // 30 seconds
        }
    }

    componentDidUpdate(prevProps) {
        const prevParams = (prevProps.match && prevProps.match.params) || {}
        const currentParams = (this.props.match && this.props.match.params) || {}
        if (currentParams.year == prevParams.year && currentParams.month == prevParams.month && this.props.onlyType == prevProps.onlyType) {
            return
        }
        this.getRepayments(this.props.context)
    }

    componentWillUnmount() {
        if (this.auditLogPoller) {
            clearInterval(this.auditLogPoller)
        }
    }

    getAuditLogs(context, year, month) {
        year = year === undefined ? '' : year
        month = month === undefined ? '' : month

        RestApiUtils.get(this.props.context, `/api/su/accounts/loans/repayments/emiTracker2/collectionStatus?year=${year}&month=${month}`,
            this.getAuditLogsCallback, null
          )
    }

    getAuditLogsCallback = (response) => {
        console.log(response)
        this.setState({
            auditLogsResponse: response
        }, () => {
            console.log("After setState:", this.state.auditLogsResponse)
        })
    }

    getRepayments(context, year, month, stp, allocation) {
        const params = (this.props.match && this.props.match.params) || {}
        year = year !== undefined ? year : (params.year || '')
        month = month !== undefined ? month : (params.month || '')
        stp = stp !== undefined ? stp : (context.filter === 'stp' ? 'stp' : '')
        allocation = allocation !== undefined ? allocation : (this.state.allocationFilter || '')

        this.setState({ year: year, month: month, repaymentsLoading: true })

        const cacheKey = (year && month)
            ? CacheKeys.EMITracker2(year, month, stp, allocation)
            : CacheKeys.EMITracker2('', '', stp, allocation)

        let cacheManager = new CacheManager({
            resource: `/api/su/accounts/loans/repayments/emiTracker2`,
            cacheKey: cacheKey,
            callback: this.getRepaymentsCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context, {}, {
            year: year,
            month: month,
            stp: stp === 'stp' ? true : false,
            allocation: allocation
        })

        this.getAuditLogs(context, year, month)
    }

    getRepaymentsCallback = (response) => {
        let errorList = []
        if (response && response.errorList) {
            response.errorList.forEach(error => {
                let msg = error ? (typeof error === 'object' ? error.message || String(error) : String(error)) : null
                if (msg) {
                    if (typeof msg === 'string' && (msg.includes('status: 500') || msg.includes('Network error: HTTP error! status: 500'))) {
                        msg = 'Internal Server Error'
                    }
                    errorList.push(msg)
                }
            })
        }
        if (response && response.message && (!response.errorList || response.errorList.length === 0)) {
            let msg = response.message
            if (typeof msg === 'string' && (msg.includes('status: 500') || msg.includes('Network error: HTTP error! status: 500'))) {
                msg = 'Internal Server Error'
            }
            errorList.push(msg)
        }

        if (!response) {
            errorList.push('Failed to load repayments data. Please try again.')
        }

        if (errorList.length > 0) {
            console.error('EMI Tracker 2.0 errors:', errorList)
        } else {
            console.log('EMI Tracker 2.0 response:', response)
        }

        const accountList = (response && response.accountEMITrackerList) || null
        const accountNRList = accountList ? accountList.filter(account => account.accountType === 'business') : []
        const accountRList = accountList ? accountList.filter(account => account.accountType === 'individual') : []
        const ym = (response && response.yearMonth) || null

        this.setState({
            repaymentsLoading: false,
            errorList: errorList.length > 0 ? errorList : null,
            accountList: accountList,
            prepaymentAccountList: (response && response.prepaymentAccountList) || null,
            accountNRList: accountNRList,
            accountRList: accountRList,
            totals: response,
            yearMonth: ym,
            year: ym ? ym.year : (this.state.year || null),
            month: ym ? ym.month : (this.state.month || null),
            previousYear: ym ? ym.prevYear : null,
            previousMonth: ym ? ym.prevMonth : null,
            nextYear: ym ? ym.nextYear : null,
            nextMonth: ym ? ym.nextMonth : null
        })
    }

    onEMITrackerDownload = () => {
        let context = this.props.context
        this.setState({
            errorList: null, downloadSubmitted: true
        })
        let dateISO = this.state.startDate
        RestApiUtils.get(this.props.context,
            `/api/su/accounts/loans/emiTrackerV2/excel/fileDownloadSignedUrl?year=${this.state.year}&month=${this.state.month}&stp=${context.filter === 'stp' ? 'true' : 'false'}`,
            this.onEMITrackerDownloadCallback, null, null
        )
    }

    onAllocationUpdateClick = (event) => {
        let selectedId = event.currentTarget.getAttribute('data-row-id')
        console.log("selectedId: ", selectedId)
        let selectedLoanId = selectedId.split('#')[0]
        let currentAllocation = selectedId.split('#')[1]
        this.setState({
            allocationUpdateMode: true,
            selectedLoanId: selectedLoanId,
            currentAllocation: currentAllocation
        })
    }

    onAllocationUpdateSuccess = (loanId, newAllocation) => {
        const updatedAccountList = (this.state.accountList || []).map((account) => {
            const hasLoan = Array.isArray(account.suLoanEMITrackerList) &&
                account.suLoanEMITrackerList.some((loan) => loan && String(loan.loanId) === String(loanId))
            if (!hasLoan) return account
            return { ...account, reconciliationAllocation: newAllocation || '' }
        })

        const updatedTotals = this.state.totals ? { ...this.state.totals, accountEMITrackerList: updatedAccountList } : null

        const cacheKey = (this.state.year && this.state.month)
            ? CacheKeys.EMITracker2(this.state.year, this.state.month, this.props.context.filter === 'stp' ? 'stp' : '', this.state.allocationFilter || '')
            : CacheKeys.EMITracker2('', '', this.props.context.filter === 'stp' ? 'stp' : '', this.state.allocationFilter || '')
        try {
            const raw = localStorage.getItem(cacheKey)
            if (raw) {
                const cachedData = JSON.parse(raw)
                if (cachedData) {
                    cachedData.accountEMITrackerList = updatedAccountList
                    CacheManager.setObject(cacheKey, cachedData)
                }
            }
        } catch (e) {
            console.error('Error updating cache for allocation:', e)
        }

        this.setState({
            accountList: updatedAccountList,
            accountNRList: updatedAccountList.filter((a) => a.accountType === 'business'),
            accountRList: updatedAccountList.filter((a) => a.accountType === 'individual'),
            totals: updatedTotals,
            allocationUpdateMode: false,
        })
    }

    onReasonUpdateSuccess = (loanId, newReason) => {
        if (!newReason || (typeof newReason === 'string' && !newReason.trim())) {
            try {
                CacheManager.removeByPrefix('EMITracker2')
            } catch (e) {
                console.error('Error clearing cache on reason reset:', e)
            }
            window.location.reload()
            return
        }

        const updatedAccountList = (this.state.accountList || []).map((account) => {
            const hasLoan = Array.isArray(account.suLoanEMITrackerList) &&
                account.suLoanEMITrackerList.some((loan) => loan && String(loan.loanId) === String(loanId))
            if (!hasLoan) return account
            return { ...account, reasonForToCollectDifference: newReason || '' }
        })

        const updatedTotals = this.state.totals ? { ...this.state.totals, accountEMITrackerList: updatedAccountList } : null

        const cacheKey = (this.state.year && this.state.month)
            ? CacheKeys.EMITracker2(this.state.year, this.state.month, this.props.context.filter === 'stp' ? 'stp' : '', this.state.allocationFilter || '')
            : CacheKeys.EMITracker2('', '', this.props.context.filter === 'stp' ? 'stp' : '', this.state.allocationFilter || '')
        try {
            const raw = localStorage.getItem(cacheKey)
            if (raw) {
                const cachedData = JSON.parse(raw)
                if (cachedData) {
                    cachedData.accountEMITrackerList = updatedAccountList
                    CacheManager.setObject(cacheKey, cachedData)
                }
            }
        } catch (e) {
            console.error('Error updating cache for reason:', e)
        }

        this.setState({
            accountList: updatedAccountList,
            accountNRList: updatedAccountList.filter((a) => a.accountType === 'business'),
            accountRList: updatedAccountList.filter((a) => a.accountType === 'individual'),
            totals: updatedTotals,
            reasonUpdateMode: false,
            currentReason: null,
            selectedLoanId: null
        })
    }

    onReasonUpdateClick = (event) => {
        let selectedLoanId = event.currentTarget.getAttribute('data-loan-id')
        let selectedColumn = event.currentTarget.getAttribute('data-column')
        let selectedReason = event.currentTarget.getAttribute('data-reason')
        if (selectedReason === null || selectedReason === undefined) {
            for (const account of (this.state.accountList || [])) {
                const foundLoan = (account.suLoanEMITrackerList || []).find(l => l && String(l.loanId) === String(selectedLoanId))
                if (foundLoan) {
                    selectedReason = foundLoan.reasonForCollectDifference || ''
                    break
                }
            }
        }
        console.log("selectedColumn: ", selectedColumn, "selectedReason: ", selectedReason)
        this.setState({
            reasonUpdateMode: true,
            selectedLoanId: selectedLoanId,
            currentReason: selectedReason || '',
            isToCollect: selectedColumn === 'toCollect' ? true : false
        })
    }

    onEMITrackerDownloadCallback = (response) => {
        this.setState({ errorList: response.errorList, downloadSubmitted: false })

        if (response.errorList.length === 0) {
            const link = document.createElement('a')
            link.href = response.signedUrl.signedUrl
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)

            setTimeout(() => {
                this.setState({ downloadMode: false })
            }, 2000)
        }
    }

    onPreviousClick = (e) => {
        if (e && e.preventDefault) e.preventDefault()
        let context = this.props.context
        const prevYear = this.state.previousYear
        const prevMonth = this.state.previousMonth
        if (prevYear && prevMonth) {
            const isRetail = (this.props.onlyType ? this.props.onlyType : this.state.onlyType) === 'individual'
            const targetUrl = isRetail
                ? `/su/repayments/2.0/${prevYear}/${prevMonth}/retail`
                : `/su/repayments/2.0/${prevYear}/${prevMonth}`
            if (this.props.history) {
                this.props.history.push(targetUrl)
                return
            }
        }
        this.getRepayments(context, prevYear, prevMonth, context.filter)
    }

    onNextClick = (e) => {
        if (e && e.preventDefault) e.preventDefault()
        let context = this.props.context
        const nextYear = this.state.nextYear
        const nextMonth = this.state.nextMonth
        if (nextYear && nextMonth) {
            const isRetail = (this.props.onlyType ? this.props.onlyType : this.state.onlyType) === 'individual'
            const targetUrl = isRetail
                ? `/su/repayments/2.0/${nextYear}/${nextMonth}/retail`
                : `/su/repayments/2.0/${nextYear}/${nextMonth}`
            if (this.props.history) {
                this.props.history.push(targetUrl)
                return
            }
        }
        this.getRepayments(context, nextYear, nextMonth, context.filter)
    }

    onTypeChange = (type) => {
        let context = this.props.context
        this.getRepayments(context, this.state.year, this.state.month, type)
    }

    onAllocationTabChange = (tabName) => {
        const allocationMap = {
            'All': '',
            'Good Standing': 'GS',
            'EWS': 'EWS',
            'NPA': 'Default Expected',
        }
        const allocation = allocationMap[tabName] || ''
        if (tabName === this.state.selectedAllocationTab) return

        let context = this.props.context
        this.setState({
            selectedAllocationTab: tabName,
            allocationFilter: allocation,
            accountList: null,
            prepaymentAccountList: null,
            accountNRList: null,
            accountRList: null,
            totals: null,
            errorList: null,
            repaymentsLoading: true,
        }, () => {
            this.getRepayments(context, this.state.year, this.state.month, context.filter, allocation)
        })
    }

    // onPreviousClick = () => {
    //     let month = this.state.totals.month == 1 ? 12 : this.state.totals.month - 1
    //     let year = this.state.totals.month == 1 ? this.state.totals.year - 1 : this.state.totals.year
    //     let context = this.props.context
    //     this.getRepayments(context, year, month)
    //   }

    //   onNextClick = () => {
    //     let month = this.state.totals.month == 12 ? 1 : this.state.totals.month + 1
    //     let year = this.state.totals.month == 12 ? this.state.totals.year + 1 : this.state.totals.year
    //     let context = this.props.context
    //     this.getRepayments(context, year, month)
    //   }

    onShowDetailsChange = () => {
        let newChecked = !this.state.checked
        CacheManager.setObject(CacheKeys.AccountRepaymentsChecked(), { checked: newChecked })
        this.setState({
            checked: newChecked
        })
    }

    onRefreshClick = () => {
        let context = this.props.context
        CacheManager.removeObject(CacheKeys.EMITracker2(this.state.year, this.state.month, context.filter, this.state.allocationFilter))
        this.setState({ accountList: null, prepaymentAccountList: null, errorList: null, totals: null, repaymentsLoading: true }, () => {
            this.getRepayments(this.props.context, this.state.year, this.state.month, context.filter)
        })
    }

    onSaveEMITracker = () => {
        let context = this.props.context
        this.setState({ saveSuccessMsg: null, errorList: null, saveLoading: true })
        RestApiUtils.post(this.props.context,
            `/api/su/accounts/loans/saveEMITracker`,
            this.onSaveEMITrackerCallback,
            {
                year: this.state.year,
                month: this.state.month
            }
        )
    }

    onSaveEMITrackerCallback = (response) => {
        // Handle case where response is null or undefined
        if (!response) {
            this.setState({
                errorList: [{ message: 'Failed to save EMI Tracker. Please try again.' }],
                saveSuccessMsg: null,
                saveLoading: false,
            })
            return
        }

        // Handle case where errorList doesn't exist or is empty
        if (!response.errorList || response.errorList.length === 0) {
            // Show success message
            this.setState({
                saveSuccessMsg: 'EMI Tracker saved successfully',
                errorList: null,
                saveLoading: false,
            })
            // Clear success message after 2 seconds
            setTimeout(() => {
                this.setState({ saveSuccessMsg: null })
            }, 2000)
        } else {
            // Highlight error
            this.setState({
                errorList: response.errorList,
                saveSuccessMsg: null,
                saveLoading: false,
            })
        }
    }

    onCollectionEMI = () => {
        let context = this.props.context
        this.setState({ saveSuccessMsg: null, errorList: null, collectionLoading: true })
        RestApiUtils.post(this.props.context,
            `/api/su/collection/run/orchestrator`,
            this.onCollectionEMICallback
        )
    }

    onCollectionEMICallback = (response) => {
        if (!response) {
            this.setState({
                errorList: [{ message: 'Failed to Initiate Collections Orchestrator. Please try again.' }],
                saveSuccessMsg: null,
                collectionLoading: false,
            })
            return
        }

        if (!response.errorList || response.errorList.length === 0) {
            this.setState({
                saveSuccessMsg: 'Collection EMI processed successfully',
                errorList: null,
                collectionLoading: false,
            })
            setTimeout(() => {
                this.setState({ saveSuccessMsg: null })
            }, 2000)
        } else {
            this.setState({
                errorList: response.errorList,
                saveSuccessMsg: null,
                collectionLoading: false,
            })
        }
    }

    onApprovePayables = () => {
        let context = this.props.context
        const currentDateISO = new Date().toISOString().slice(0, 10)
        this.setState({ saveSuccessMsg: null, errorList: null, approveLoading: true })
        RestApiUtils.post(this.props.context,
            `/api/su/payables/${currentDateISO}/pending/approveAll`,
            this.onApprovePayablesCallback
        )
    }

    onApprovePayablesCallback = (response) => {
        if (!response) {
            this.setState({
                errorList: [{ message: 'Failed to approve payables. Please try again.' }],
                saveSuccessMsg: null,
                approveLoading: false,
            })
            return
        }

        if (!response.errorList || response.errorList.length === 0) {
            this.setState({
                saveSuccessMsg: 'Payables approved successfully',
                errorList: null,
                approveLoading: false,
            })
            setTimeout(() => {
                this.setState({ saveSuccessMsg: null })
            }, 2000)
        } else {
            this.setState({
                errorList: response.errorList,
                saveSuccessMsg: null,
                approveLoading: false,
            })
        }
    }

    onSaveAndApprove = () => {
        this.setState({ saveSuccessMsg: null, errorList: null, saveLoading: true, saveAndApproveStep: 'saving' })
        RestApiUtils.post(this.props.context,
            `/api/su/accounts/loans/saveEMITracker`,
            this.onSaveAndApproveStep1Callback,
            { year: this.state.year, month: this.state.month }
        )
    }

    onSaveAndApproveStep1Callback = (response) => {
        if (!response || (response.errorList && response.errorList.length > 0)) {
            this.setState({
                errorList: response ? response.errorList : [{ message: 'Failed to save EMI Tracker. Please try again.' }],
                saveSuccessMsg: null,
                saveLoading: false,
                saveAndApproveStep: null,
            })
            return
        }
        const currentDateISO = new Date().toISOString().slice(0, 10)
        this.setState({ saveLoading: false, approveLoading: true, saveAndApproveStep: 'approving' })
        RestApiUtils.post(this.props.context,
            `/api/su/payables/${currentDateISO}/pending/approveAll`,
            this.onSaveAndApproveStep2Callback
        )
    }

    onSaveAndApproveStep2Callback = (response) => {
        if (!response) {
            this.setState({
                errorList: [{ message: 'Failed to approve payables. Please try again.' }],
                saveSuccessMsg: null,
                approveLoading: false,
                saveAndApproveStep: null,
            })
            return
        }
        if (!response.errorList || response.errorList.length === 0) {
            this.setState({
                saveSuccessMsg: 'EMI Tracker saved and Payables approved successfully',
                errorList: null,
                approveLoading: false,
                saveAndApproveStep: null,
            })
            setTimeout(() => { this.setState({ saveSuccessMsg: null }) }, 2000)
        } else {
            this.setState({
                errorList: response.errorList,
                saveSuccessMsg: null,
                approveLoading: false,
                saveAndApproveStep: null,
            })
        }
    }
}

export default withRouter(EMITracker2PageSF)
